import React, { FC } from 'react';
import { Tabs as Wrapper } from './styles';

const Tabs: FC = ({ children }) => {
    return <Wrapper>{children}</Wrapper>;
};

export default Tabs;
